// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"20bab1b6","173":"f4fe90a4","573":"896e0cd5","597":"6476e824","671":"11d7edce","701":"eeeb95f6","707":"f6427db6","761":"b81e8956","823":"9beca1a4"}[chunkId] + ".chunk.js";
};